import { useContext } from 'react'
import { ReportFormContext } from '../../../Contexts/ReportFormContext'
import { type AnonymityConfig, resolveIsAnonymous } from '../../../utils/resolveIsAnonymous'

export const useFooterAnonymity = (reportSource: AnonymityConfig) => {
  const { formAnonymity, isSentReportAnonymous } = useContext(ReportFormContext)

  if (formAnonymity) {
    return resolveIsAnonymous(formAnonymity)
  }

  if (isSentReportAnonymous !== null) {
    return isSentReportAnonymous
  }

  return resolveIsAnonymous({ ...reportSource, choice: null })
}
